module.exports = __webpack_public_path__ + "img/yandex.5dfabf20.png";